var _path, _path2, _rect, _line, _line2, _line3, _line4, _line5, _line6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMassMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.44727 1.41333H14.1501V14.5868H3.94726C2.56655 14.5868 1.44727 13.4675 1.44727 12.0868V1.41333Z",
    stroke: "#1D1D1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5527 8.5H14.2934V14.5752C15.5612 14.4541 16.5527 13.3862 16.5527 12.0866V8.5Z",
    stroke: "#1D1D1D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.65039,
    y: 3.55127,
    width: 4.5835,
    height: 3.51475,
    stroke: "#1D1D1D"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10.1758,
    y1: 3.44214,
    x2: 12.447,
    y2: 3.44214,
    stroke: "#1D1D1D"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 3.15039,
    y1: 8.82886,
    x2: 12.4473,
    y2: 8.82886,
    stroke: "#1D1D1D"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 10.1758,
    y1: 5.20825,
    x2: 12.447,
    y2: 5.20825,
    stroke: "#1D1D1D"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 3.15039,
    y1: 10.595,
    x2: 12.4473,
    y2: 10.595,
    stroke: "#1D1D1D"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 10.1758,
    y1: 6.97461,
    x2: 12.447,
    y2: 6.97461,
    stroke: "#1D1D1D"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 3.15039,
    y1: 12.3613,
    x2: 12.4473,
    y2: 12.3613,
    stroke: "#1D1D1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMassMedia);
export default __webpack_public_path__ + "static/media/mass-media.1d45555f35980500d3618bc1d913e2e7.svg";
export { ForwardRef as ReactComponent };